<div class="row" style="background-color: white;">
  <div id="pageTitle" style="text-align: center;">Data Studio Report</div>
</div>
<div id="content">
  <iframe width="100%" height="800"
    src="https://datastudio.google.com/embed/reporting/06d3aff6-ee1b-4076-a0d8-f305fd30468b/page/LX5jB" frameborder="0"
    style="border:0" allowfullscreen></iframe>
</div>